import { render, staticRenderFns } from "./QApproveDigitalLeadOrderDataTable.vue?vue&type=template&id=f2475668&scoped=true&"
import script from "./QApproveDigitalLeadOrderDataTable.vue?vue&type=script&lang=js&"
export * from "./QApproveDigitalLeadOrderDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QApproveDigitalLeadOrderDataTable.vue?vue&type=style&index=0&id=f2475668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2475668",
  null
  
)

export default component.exports